export const OLLAMA_BASE_URL = 'https://ollama.soft.prod.hwmt.link'
export const OLLAMA_MODEL = 'gemma4:e4b'
export const OLLAMA_BEARER = ''

export const CRM_JSON_MAX_CHARS = 60000
export const MAX_IMAGES = 6
export const OLLAMA_TIMEOUT_MS = 30000
